<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 10V3H18V10"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.8 18H4.9C4.39609 18 3.91282 17.8127 3.5565 17.4793C3.20018 17.1459 3 16.6937 3 16.2222V11.7778C3 11.3063 3.20018 10.8541 3.5565 10.5207C3.91282 10.1873 4.39609 10 4.9 10H20.1C20.6039 10 21.0872 10.1873 21.4435 10.5207C21.7998 10.8541 22 11.3063 22 11.7778V16.2222C22 16.6937 21.7998 17.1459 21.4435 17.4793C21.0872 17.8127 20.6039 18 20.1 18H18.2"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18 14H7V22H18V14Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
